import type { manage as en } from '@/i18n/locales/en/manage';
import type { Translation } from '@/i18n/types';

export const manage: Translation<typeof en> = {
  backToApp: 'Uygulamaya dön',
  sections: {
    companies: {
      label: 'Şirketler',
      items: {
        companies: 'Şirketler',
        pilots: 'Pilotlar',
      },
    },
    people: {
      label: 'Kişiler',
      items: {
        users: 'Tüm kullanıcılar',
        linkIdentities: 'Kimlikleri bağla',
        admins: 'Yöneticiler',
      },
    },
    audit: {
      label: 'Denetim',
      items: {
        audit: 'Denetim günlüğü',
      },
    },
    subscriptions: {
      label: 'Abonelikler',
      items: {
        config: 'Provider configuration',
        products: 'Ürünler ve sağlayıcılar',
        userLedger: 'Kullanıcı defteri',
      },
    },
    system: {
      label: 'Sistem',
      items: {
        statistics: 'İstatistik durumu ve yeniden oluşturma',
        requests: 'API istekleri',
      },
    },
    support: {
      label: 'Destek',
      items: {
        tickets: 'Talepler',
      },
    },
    overview: {
      label: 'Genel Bakış',
      items: {
        overview: "KPI'lar",
      },
    },
  },
  placeholders: {
    statistics: {
      title: 'İstatistik durumu ve yeniden oluşturma',
      note: 'İstatistik durumu ve yeniden oluşturma kontrolleri ayrı bir plandır — bu menü öğesi yeri ayırır, ekran aşama 1’de oluşturulmamıştır.',
    },
  },
  usersAll: {
    title: 'Tüm kullanıcılar',
    linkIdentities: 'Kimlikleri bağla',
    empty: 'Henüz hiçbir kimlik yok.',
    name: 'Ad',
    email: 'E-posta',
    language: 'Dil',
    login: 'Giriş',
    yes: 'evet',
    no: 'hayır',
    view: 'Görüntüle',
    rowsLabel: 'kullanıcılar',
  },
  linkIdentities: {
    title: 'Yinelenen kimlikleri bağla',
    lead: 'Takma ad var olmaya devam eder, ancak birincil kimliği işaret eder. Platform yöneticisi değilseniz, ikisinden birinin girişi olmamalı ve girişi olan kimlik birincil olur — sunucu bunu, burada ne seçilirse seçilsin kontrol eder.',
    candidatesLabel: 'yönettiğiniz kişiler',
    needTwo: 'Bağlamak için kapsamınızda en az iki kişiye ihtiyacınız var.',
    aliasLabel: 'Takma ad (bu kimlik işaretçi haline gelir)',
    primaryLabel: 'Birincil (kalan kimlik)',
    choose: 'Seçin…',
    hasLogin: '(girişi var)',
    noLogin: '(girişi yok)',
    link: 'Bağla',
    cancel: 'İptal',
  },
  erase: {
    completedTitle: 'Silme tamamlandı',
    completedText:
      'Kimlik silindi. Denetim günlüğü takma ada dönüştürülür, silinmez; bağlı kimlikler işaretçileri sıfırlanmış olarak var olmaya devam eder.',
    departmentsWithoutAdmin: 'Yöneticisiz kalan departmanlar: {{names}}',
    measurementsNotDeleted:
      'Veri alım hizmetindeki ölçümler SİLİNMEDİ — bu özellik henüz orada mevcut değil. Bunu panelin dışında takip edin.',
    backToUsers: 'Kullanıcılara geri dön',
    title: 'Bu kişiyi sil',
    lead: 'Bu işlem {{userId}} kimliğini geri alınamaz şekilde kalıcı olarak siler: kullanıcı kaydını, üyeliklerini, rızalarını ve yetkilerini. Bağlı kimlikler kalır; Gengee kaynaklı veriler kalır; denetim günlüğü takma ada dönüştürülür. Onaylamak için {{confirmWord}} yazın.',
    confirmWord: 'SİL',
    confirmationLabel: 'Onay',
    erasePermanently: 'Kalıcı olarak sil',
    cancel: 'İptal',
  },
  requests: {
    title: 'API istekleri',
    lead: 'Bir kaynak için veri alım API’sinin kaydettiği istekler, en yeniden en eskiye, isteğe bağlı olarak bir zaman aralığıyla sınırlandırılmış.',
    filterSource: 'Kaynağa göre filtrele',
    sourcePlaceholder: 'kaynak id’si',
    filterFrom: 'Başlangıç',
    filterTo: 'Bitiş',
    filter: 'Filtrele',
    enterSourceHint: 'İstek günlüğünü yüklemek için bir kaynak id’si girin.',
    empty: 'Bu kaynak ve aralık için kaydedilmiş istek yok.',
    when: 'Ne zaman',
    method: 'Yöntem',
    path: 'Yol',
    status: 'Durum',
    rowsLabel: 'istekler',
  },
};
